import { useMutation } from '@tanstack/react-query';
import { logoutDirect } from '@timetable/api';
import { useAuthStore } from '@/store/authStore';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@/lib/queryClient';

export function useLogout() {
  const navigate = useNavigate();
  const clearAuth = useAuthStore((state) => state.clearAuth);

  return useMutation({
    mutationFn: () => logoutDirect(),
    onSuccess: () => {
      // Clear auth state
      clearAuth();

      // Clear all queries
      queryClient.clear();

      // Navigate to login
      navigate('/login');
    },
    onError: (error: Error) => {
      console.error('Logout failed:', error);
      // Still clear auth on error
      clearAuth();
      navigate('/login');
    },
  });
}
